import Vue   from 'vue'
import tools from './tools'

Vue.filter('comma', tools.comma) // 금액 컴마 찍어주는 필터
Vue.filter('insertHyphen', tools.insertHyphen) // 하이픈 필터
Vue.filter('insertColon', tools.insertColon) // 콜론 필터
Vue.filter('left' , tools.left)  // left 필터
Vue.filter('right', tools.right) // right 필터
Vue.filter('highlight', tools.highlight) // 검색어 강조
Vue.filter('absComma', tools.absComma) // 금액 컴마 및 절대값 반환

Vue.filter('org_br', tools.f_org_br)
